import { useModuleFilter } from '@/context/ModuleFilter';
import type { MetricRange } from '@/schemas/commons';
import { useConversations } from '@/services/Conversations';
import { useMetrics } from '@/services/Metrics';

export const useDashboardData = (range: MetricRange) => {
	const { selectedModule } = useModuleFilter();
	const metrics = useMetrics({ range, moduleName: selectedModule });
	const recent = useConversations({ page: 1, pageSize: 5, moduleName: selectedModule });

	return {
		metrics,
		recent,
		isLoading: metrics.isLoading || recent.isLoading,
		isError: metrics.isError || recent.isError,
	};
};
